module.exports = __webpack_public_path__ + "static/media/cpes.d613cebb.png";